import { render, staticRenderFns } from "./PlanejamentoContratoFormAcoesVisao.vue?vue&type=template&id=5dba224c"
import script from "./PlanejamentoContratoFormAcoesVisao.vue?vue&type=script&lang=js"
export * from "./PlanejamentoContratoFormAcoesVisao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports